module.exports = __webpack_public_path__ + "static/media/icons-hb-gift.b19448e4.svg";